import { operatingCountries } from 'constants/user';

// redux-form validators
export const required = ((value) => {
  return value ? undefined : 'This field is required';
});

export const number = ((value) => {
  return value && isNaN(Number(value)) ? 'Must be a number' : undefined;
});

export const maxLength = max => ((value) => {
  return value && value.length > max ? `Must be ${ max } characters or less` : undefined;
});

export const minLength = min => ((value) => {
  return value && value.length < min ? `Must be at least ${ min } characters` : undefined;
});

export const exactLength = length => ((value) => {
  return value && value.length !== length ? `Must be exactly ${ length } characters` : undefined;
});

export const email = ((value) => {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address' : undefined;
});

export const url = ((value) => {
  return value && !/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-zA-Z0-9]+([\-\.\_]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g.test(value)
  ? 'Invalid url' : undefined;
});

export const currency = ((value) => {
  return value && !/^-?[\d]*?(.\d{2})?$/.test(value) ? 'Invalid. Ex 10.99' : undefined;
});

export const match = compareValue => ((value) => {
  return value && compareValue !== value ? 'Fields do not match' : undefined;
});

// inline validators
export const inlineCurrency = ((value) => {
  // return (value && /^-?[\d]*(?:\.\d{1,2})?$/.test(value)) || false;
  return (value && /^-?(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/.test(value)) || false;
});

export const inlineNumber = ((value) => {
  return (value && /^[0-9]*$/.test(value)) || false;
});

// inline decimal validator
export const inlineDecimal = (value, precision = 2) =>
  value && RegExp(`^[0-9]*(\\.\\d{0,${precision}})?$`).test(value) || false;

// inline Currency validators
export const inlineCurrency2 = ((value) => {
  return (value && /^-?[\d]*?(.\d{1,4})?$/.test(value)) || false;
});

// inline validators
export const inlineCurrency3s = ((value) => {
  return (value && /^-?(?=.*[1-9])\d*(?:\.\d{1,3})?$/.test(value)) || false;
});

export const inlinePlusCurrency = ((value) => {
  // return (value && /^[\d]*?(\.\d{1,2})?$/.test(value)) || false;
  return (value && /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/.test(value)) || false;
});

export const noSpaceText = ((value) => {
  return value && value.trim().length > 0 ? 'Must be valid text' : undefined;
});

export const zipValidation = country => ((value) => {
  if (country === operatingCountries.canada) {
    return value && (!/^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/.test(value) || exactLength(7)(value)) ? 'Invalid Canadian postal code' : undefined;
  }
  return number(value) || exactLength(5)(value);
});

// inline digit and decimal validator
export const inlineDigitAndDecimal = ((value) => {
  return (value && /^([0-9]{1,3})(\.\d{0,2})?$/.test(value)) || false;
});

/**
 * Validate true only if given is a number that can have upto 4 decimal
 * @param {Number} value value to be tested
 * @returns {Boolean} value is valid
 */
export const validateAmount = value => {
  if (value == 0) {
    return true;
  }
  return (value && /^([0-9]{0,10})(\.\d{0,4})?$/.test(value)) || false
};

/**
 * Validate true only if given is a number between 0 and 100 that can have upto 2 decimal places
 * @param {Number} value value to be tested
 * @returns {Boolean} value is valid
 */
export const validateYield = value => {
  if (value == 0 || value == 100) {
    return true;
  }
  return (value && /^([0-9]{0,2})(\.\d{0,2})?$/.test(value)) || false
};

/**
 * Validate batch recipe yield
 * to have 4-digits and 2-decimals
 * 
 * @param {Number} value value to be tested
 * @returns {Boolean} value is valid
 */
export const validateBatchRecipeYield = value => {
  return !!value && /^([0-9]{0,4})(\.\d{0,2})?$/.test(value)
};
